"use client";

import { trustPartners } from "@/lib/data/site";
import { motion } from "framer-motion";

export function TrustStrip() {
  const items = [...trustPartners, ...trustPartners];

  return (
    <section className="relative overflow-hidden border-y border-border bg-background-elevated/80 py-10 sm:py-12">
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-accent/55 to-transparent" />
      <div className="absolute inset-x-0 bottom-0 h-px bg-gradient-to-r from-transparent via-accent-tertiary/35 to-transparent" />
      <div className="container-wide relative mb-6 sm:mb-7">
        <motion.p
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center text-xs font-semibold uppercase tracking-[0.22em] text-foreground/70"
        >
          Trusted stack for custom software, AI engineering &amp; cloud delivery
        </motion.p>
      </div>
      <div className="relative overflow-hidden">
        <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-16 bg-gradient-to-r from-background-elevated to-transparent sm:w-24" />
        <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-16 bg-gradient-to-l from-background-elevated to-transparent sm:w-24" />
        <div className="flex w-max max-w-none animate-marquee gap-4 px-4 sm:gap-8">
          {items.map((item, i) => (
            <div
              key={`${item}-${i}`}
              className="card-lift flex h-12 min-w-[132px] items-center justify-center rounded-full border border-border bg-card/80 px-5 text-sm font-medium tracking-wide text-foreground/80 backdrop-blur sm:min-w-[150px]"
            >
              {item}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
